import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Angulartics2Module } from 'angulartics2';
import { SharedModule } from 'app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { BulkUpdateValidationService } from '@app/shared/bulk-update-validation/bulk-update-validation.service';

import { AdminComponent } from './admin.component';
import { CompanyDashboardComponent } from './company-dashboard/company-dashboard.component';
import { TranslateModule } from '@ngx-translate/core';

// TODO: Split into sub modules
const components = [
  AdminComponent,
  CompanyDashboardComponent
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    Angulartics2Module,
    TooltipModule.forRoot(),
    TranslateModule
  ],
  declarations: components,
  exports: components,
  providers: [
    BulkUpdateValidationService
  ]
})
export class AdminComponentsModule { }
